module.exports = __webpack_public_path__ + "static/media/expand.95a46151.svg";